export default "__VITE_ASSET__6b6b041b__"